module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-vehicle-slot"
  }, [(_vm.$is('asset-management-list')) ? _c('div', {
    staticClass: "asset-management-list"
  }, [_c('div', {
    staticClass: "item-vehicle-slot-id"
  }, [_vm._v("VS-" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "item-vehicle-slot-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
    staticClass: "item-vehicle-slot-name"
  }, [_vm._v("Booking mode " + _vm._s(_vm.item.reservation_type))])]) : _c('div', {
    staticClass: "card inner-content"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('h3', [_vm._v(_vm._s(_vm.item.name) + "  [disabled: " + _vm._s(_vm.item.disabled) + "]")])]), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v(_vm._s(_vm.item.reservation_type) + " - " + _vm._s(_vm.item.vehicle.model) + " - " + _vm._s(_vm.item.vehicle.plate))]), _c('button', {
    staticClass: "button success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.enable
    }
  }, [_vm._v("Enable")]), _c('button', {
    staticClass: "button warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.disable
    }
  }, [_vm._v("Disable")])]), _c('accordion', {
    attrs: {
      "items": _vm.item
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4af61123!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/VehicleSlot.vue
// module id = 2322
// module chunks = 1